import { Drawer, Empty, Skeleton, Table, Typography } from "antd";
import { EyeOutlined, LoadingOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRotoPaginationListNew } from "services/redux/Roto/action";
import InfiniteScroll from "react-infinite-scroll-component";
import RotoTemplateDetails from "views/Roto/RotoMain/RotoTemplateDetails";

export default function RotoOnlyTemplateViewTable({ filterData }) {
  const dispatch = useDispatch();

  const { rotoDetails, getRotoListingLoading } = useSelector(
    (state) => state.rotoReducer
  );
  const [data, setData] = useState("");
  const [viewDetailsDrawer, setViewDetailsDrawer] = useState(false);
  const [loadingRecord, setLoadingRecord] = useState({
    key: null,
    isLoading: false,
  });
  const [currentPage, setCurrentpage] = useState(1);
  const pageSize = 30;

  const columns = [
    {
      title: "S No",
      key: "sno",
      render: (text, object, index) => index + 1,
      width: "5%",
    },
    {
      title: "Tender No",
      dataIndex: "tenderNo",
      key: "tenderNo",
      width: "10%",
    },
    {
      title: "Project Name",
      dataIndex: "projectName",
      key: "projectName",
      width: "10%",
    },
    {
      title: "SOW",
      dataIndex: "sow",
      key: "sow",
      width: "10%",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (record) => {
        if (!isEmpty(record) && record.length > 0) {
          return record.map((category) => (
            <div key={category?.id}>{category?.name}</div>
          ));
        }
      },
      width: "10%",
    },
    {
      title: "Sector",
      dataIndex: "sector",
      key: "sector",
      render: (record) => {
        if (!isEmpty(record) && record.length > 0) {
          return record.map((sector) => (
            <div key={sector?.id}>{sector?.name}</div>
          ));
        }
      },
      width: "10%",
    },
    {
      title: "Client",
      dataIndex: "clientCompany",
      key: "clientCompany",
      width: "20%",
      render: (record) => {
        if (!isEmpty(record)) {
          return (
            <div style={{ display: "block", width: "100%" }}>
              {record.slice(0, 2).map((item, index) => (
                <span key={index}>{item?.name}</span>
              ))}
              {record.length > 2 && <span>...</span>}
            </div>
          );
        }
      },
    },
    {
      title: "Bidding Company",
      dataIndex: "biddingCompany",
      key: "biddingCompany",
      width: "25%",
      render: (record) => {
        if (!isEmpty(record)) {
          return (
            <div style={{ display: "block", width: "100%" }}>
              {record.slice(0, 2).map((item, index) => (
                <div key={index}>
                  {item.companyInfo?.slice(0, 2).map((company) => (
                    <div key={company?.id}>{company?.name}</div>
                  ))}
                  {item.companyInfo?.length > 2 && <span>...</span>}
                </div>
              ))}
              {record.length > 2 && <span>...</span>}
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Action",
      render: (record) => (
        <>
          <div
            className="task-view-btn"
            style={{
              margin: "20px",
            }}
            onClick={() => handleClick(record)}
          >
            {loadingRecord.key === record.id && loadingRecord.isLoading ? (
              <LoadingOutlined />
            ) : (
              <EyeOutlined />
            )}
          </div>
        </>
      ),
      width: "10%",
    },
  ];

  // useEffect(() => {
  //   const params = {
  //     skipCount: 0,
  //     maxResultCount: 200,
  //   };
  //   dispatch(getRotoPaginationListNew(params));
  // }, []);

  useEffect(() => {
    if (!isEmpty(rotoDetails?.items)) {
      const newCurrentPage = rotoDetails?.items?.length / pageSize;
      setCurrentpage(newCurrentPage);
    }
  }, [rotoDetails]);

  const getMoreData = () => {
    getData(pageSize, currentPage * pageSize, true);
  };

  const getData = (MaxResultCount = pageSize, SkipCount, loadMore = true) => {
    dispatch(
      getRotoPaginationListNew(
        {
          ...filterData,
          skipCount: SkipCount,
          maxResultCount: MaxResultCount,
        },
        loadMore
      )
    );
  };

  const handleClick = (record) => {
    setLoadingRecord({
      key: record.id,
      isLoading: true,
    });
    setData(record);
    setTimeout(() => {
      setViewDetailsDrawer(true);
      setLoadingRecord({
        key: null,
        isLoading: false,
      });
    }, 500); // Simulate a delay for loading
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <Typography.Title level={5}>
          <Typography.Text style={{ textAlign: "left" }}>
            Total Roto - {rotoDetails?.totalCount}
          </Typography.Text>
        </Typography.Title>
      </div>
      {!isEmpty(rotoDetails?.items) ? (
        <>
          <div
            id="rotoDiv"
            style={{
              height: "calc(100vh - 200px)",
              overflowY: "auto",
            }}
          >
            <InfiniteScroll
              dataLength={rotoDetails?.items?.length}
              next={getMoreData}
              hasMore={rotoDetails?.totalCount > rotoDetails?.items?.length}
              loader={<Skeleton active={4} />}
              endMessage={
                <Typography.Title
                  level={4}
                  strong
                  style={{ textAlign: "center" }}
                >
                  End
                </Typography.Title>
              }
              scrollThreshold={0.6}
              scrollableTarget="rotoDiv"
            >
              <Table
                columns={columns}
                dataSource={rotoDetails?.items}
                pagination={false}
                // loading={getRotoListingLoading}
                rowKey="id"
              />
            </InfiniteScroll>
            <Drawer
              visible={viewDetailsDrawer}
              title="Roto Details"
              placement="right"
              onClose={() => setViewDetailsDrawer(false)}
              width={543}
            >
              <RotoTemplateDetails data={data} />
            </Drawer>
          </div>
        </>
      ) : (
        <Empty />
      )}
    </>
  );
}
